
enum CheckResult {
    EARLY = 0,
    CONFIRMED = 1
}

export default CheckResult;